import { usePopperTooltip } from "react-popper-tooltip";
import { FaBoltLightning } from "react-icons/fa6";
import RapidDownloadButton from "./rapidDownloadButton";
import useApiClient from "../../hooks/useApiClient";
import { paginatedApiToBatchGenerator } from "../../apiUtils";

const RapidDownloadOption = ({ dataSet }: { dataSet: any }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip();

  const api = useApiClient();
  const dataAssetBatchGenerator = paginatedApiToBatchGenerator({
    fn: api.dataAccess.searchDataAssets.bind(api.dataAccess),
    args: { dataSetPublicIds: dataSet.public_id },
  });

  return (
    <>
      <RapidDownloadButton
        dataAssetBatchGenerator={dataAssetBatchGenerator}
        totalSize={dataSet.total_data_volume}
        totalFileCount={dataSet.number_of_assets}
        className="w-26 mt-2 px-2 py-1"
        ref={setTriggerRef}
      >
        <FaBoltLightning className="mr-4 align-middle" />
        <p className="mr-3">Rapid</p>
      </RapidDownloadButton>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container text-sm" })}
        >
          <p>Download multiple assets at a time directly from Cloud Storage.</p>
          <p>This is the fastest option, but it requires more bandwidth.</p>
          <div {...getArrowProps({ className: "tooltip-arrow" })} />
        </div>
      )}
    </>
  );
};

export default RapidDownloadOption;
